<template>
  <div class="financial padding80">
    <Header :current="0"></Header>
    <Card cardIndex="0" ref="Card"></Card>
    <LeiMon :LeiMonList="LeiMonList" @moreModel="moreModel"></LeiMon>
    <Footer></Footer>
  </div>
</template>

<script>
import cardMixins from "@/mixins/cardMixins";
export default {
  name: "financial",
  mixins: [cardMixins],
  data() {
    return {
      LeiMonList: [
        {
          icon: require("../../assets/phone/phone_girl.png"),
          iconPosition: "left",
          title: "生活圈",
          tips:
            "生活圈是围绕银行的个人用户，为其满足基本生活需求场景和品质提升需求场景构建的本地特色服务平台，构建居民与“周边商圈、物业、社区、银行”五位一体的社区商业生态。",
          more: "",
          type: "life",
          id: "images0",
          changeType: true
        },
        {
          icon: require("../../assets/phone/phone_man.png"),
          iconPosition: "right",
          title: "生意圈",
          tips:
            "生意圈是以银行服务的核心企业的管理和经营为中心，带动其下游企业客户的供应链关系，构建供应链交易场景化，管理平台化的服务体系。",
          more: "",
          type: "business",
          id: "images1",
          changeType: false
        },
        {
          icon: require("../../assets/phone/phone_scene.png"),
          iconPosition: "left",
          title: "场景中心",
          tips:
            "场景中心是在银行线上渠道生活化运营趋势下，解决多场景接入的高成本问题，一站式接入多场景化资源。",
          more: "",
          type: "scene",
          id: "images2",
          changeType: true
        },
        {
          icon: require("../../assets/phone/phone_flow.png"),
          iconPosition: "right",
          title: "流量中心",
          tips:
            "一站式解决客流监测，客流转化和客流留存。支持多渠道，精准评估获客成本，提高广告投放ROI。",
          more: "",
          type: "flow",
          id: "images3",
          changeType: false
        },
        {
          icon: require("../../assets/phone/phone_activity.png"),
          iconPosition: "left",
          title: "活动中心",
          tips:
            "一站式营销策划与活动运营中心，助力企业搭建真正的数字化全场景营销中台。",
          more: "",
          type: "activity",
          id: "images4",
          changeType: true
        },
        {
          icon: require("../../assets/phone/phone_equity.png"),
          iconPosition: "right",
          title: "权益中心(区块链）",
          tips:
            "一站式客户运营平台，更高效，并应用区块链技术分布式管理、历史记录不可篡改，为系统的安全可靠性保驾护航，帮助商家重新定义客户全成长周期。",
          more: "",
          type: "equity",
          id: "images5",
          changeType: false
        }
      ]
    };
  },
  mounted() {},
  methods: {
    moreModel(item) {
      this.$router.push({
        path: "/financialDetail",
        query: { type: item.type }
      });
    }
  }
};
</script>

<style scoped lang="less"></style>
